export default {"src":"https://search.prod.wiggot.com/_next/static/media/monopolio-icon.4860033a.svg","height":15,"width":17,"blurWidth":0,"blurHeight":0};